import React from 'react';
import { Banner } from '../../components/Banner/';

export const Home = () => {
  return <Banner />;
};
